import * as angular from "angular";
import {CommonsService} from "../commons/services/commons-service.service";
import {AccountType} from "./types/account.type";
import {AccountsFacadeService} from "./angular/services/accounts-facade.service";
import {TextTemplateReceiverType} from "../text-templates/types/text-template-receiver.type";
import {TextTemplatePurposeType} from "../text-templates/types/text-template-purpose.type";
import TextTemplatesService from "../text-templates/services/text-templates-service.service";

angular
  .module('bringoz.admin.accounts')
  .config(AccountsStateConfig);

/* @ngInject */
function AccountsStateConfig($stateProvider) {

  $stateProvider

    //Accounts
    .state('accounts-list-supply', {
      parent: 'bringoz.site',
      url: '/accounts/supply',
      controllerAs: 'vm',
      template: '<supply-accounts account-types="vm.accountTypes"></supply-accounts>',
      controller: function (triBreadcrumbsService, site) {
        this.accountTypes = [AccountType.BusinessSupply, AccountType.PrivateSupply];

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Carriers', state: 'accounts-list-supply'});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })

    .state('accounts-list-supply-3pl', {
      parent: 'bringoz.site',
      url: '/accounts/supply-thirdParty',
      controllerAs: 'vm',
      template: '<supply-accounts account-types="vm.accountTypes"></supply-accounts>',
      controller: function (triBreadcrumbsService, site) {
        this.accountTypes = [AccountType.ThreePLSupply];
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'External Carriers', state: 'accounts-list-supply-3pl'});
        triBreadcrumbsService.addCrumb({name: 'Fleet Management'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })

    // Account
    .state('accounts-detail-supply', {
      parent: 'bringoz.site',
      url: '/accounts/supply/:id',
      abstract: true,
      controllerAs: 'vm',
      template: '<driver-account-detailed-view account-id="vm.accountId"></driver-account-detailed-view>',
      controller: function (triBreadcrumbsService, accountId: string, site) {
        this.accountId = accountId;

      },
      resolve: {
        accountId: ($stateParams, site, accountsFacadeService: AccountsFacadeService) => {
          accountsFacadeService.getOne($stateParams.id);
          return $stateParams.id;
        }
      }
    })

    // Account / Account Info
    .state('accounts-detail-supply.info', {
      url: '',
      abstract: true,
      template: '<supply-account-info account="$ctrl.account"></supply-account-info>'
    })

    // Account / Preferences
    .state('accounts-detail-supply.info.preferences', {
      url: '/preferences',
      controllerAs: 'vm',
      template: '<driver-account-preferences account="$ctrl.account" preferences="vm.preferences"></driver-account-preferences>',
      controller: function (accountId, preferences, triBreadcrumbsService) {
        this.preferences = preferences;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Preferences'});
        // triBreadcrumbsService.addCrumb({name: this.account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Carriers', state: 'accounts-list-supply'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
      resolve: {
        preferences: function (accountId, accountRequests, site) {
          return accountRequests.getPreferences(accountId)
        }
      }
    })

    // Account / Account Info / Branches
    .state('accounts-detail-supply.info.branches', {
      url: '/branches',
      controllerAs: 'vm',
      template: '<supply-account-branches account="$ctrl.account"></supply-account-branches>',
      controller: function (triBreadcrumbsService) {

        // this.branchIds = account.branchIds;

        // Bread Crumbs
        // triBreadcrumbsService.reset();
        // triBreadcrumbsService.addCrumb({name: 'Branches'});
        // triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        // triBreadcrumbsService.addCrumb({name: 'Carriers', state: 'accounts-list-supply'});
        // triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
    })

    // Account / Account Info / Depots
    .state('accounts-detail-supply.info.depots', {
      url: '/depots',
      template: '<shipper-account-depots account="$ctrl.account"></shipper-account-depots>',
      controller: function (triBreadcrumbsService) {

        // Bread Crumbs
        // triBreadcrumbsService.reset();
        // triBreadcrumbsService.addCrumb({name: 'Depots'});
        // triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        // triBreadcrumbsService.addCrumb({name: 'Carriers', state: 'accounts-list-supply'});
        // triBreadcrumbsService.addCrumb({name: 'Resources'});
      },
    })

    // Account / Active Deliveries
    .state('accounts-detail-supply.active-deliveries', {
      url: '/active-deliveries',
      pageTrack: '/account/supply/active-deliveries',
      template: '<account-delivery-active account="$ctrl.account" is-demand="isDemand"></account-delivery-active>',
      controller: function ($scope) {
        $scope.isDemand = false;
      },
    })

    .state('accounts-detail-supply.active-threepl-services', {
      url: '/active-threepl-services',
      pageTrack: '/account/supply/active-threepl-services',
      template: '<app-account-threepl-services [account]="$ctrl.account" [is-active]="true"></app-account-threepl-services>',
      controller: function ($scope) {
      }
    })

    // Account / Services History
    .state('accounts-detail-supply.delivery-history', {
      url: '/delivery-history',
      pageTrack: '/account/supply/delivery-history',
      template: '<account-delivery-history account="$ctrl.account" is-demand="isDemand"></account-delivery-history>',
      controller: function ($scope) {
        $scope.isDemand = false;
      }
    })

    .state('accounts-detail-supply.threepl-services-history', {
      url: '/threepl-services-history',
      pageTrack: '/account/supply/threepl-services-history',
      template: '<app-account-threepl-services [account]="$ctrl.account" [is-active]="false"></app-account-threepl-services>',
      controller: function ($scope) {
      }
    })

    // Account / Drivers
    .state('accounts-detail-supply.agents-list', {
      url: '/agents-list',
      pageTrack: '/account/supply/agents-list',
      template: '<account-agents-view account="$ctrl.account"></account-agents-view>'
    })

    // // Account / Report //TODO delete
    // .state('accounts-detail-supply.commission-report', {
    //   url: '/commission-report',
    //   pageTrack: '/account/supply/commission-report',
    //   template: '<account-commissions-view account="$ctrl.account" agent-id="$ctrl.agent.id"></account-commissions-view>'
    // })

    //TODO working on
    .state('accounts-detail-supply.commission', {
      abstract: true,
      url: '/commission-report',
      reloadOnSearch: false,
      template: '<account-commissions-view show-consolidated="true" account="$ctrl.account"></account-commissions-view>',
    })

    .state('accounts-detail-supply.commission.expenses', {
      url: '/expenses?:categoryIds&:statuses&:agentIds&:from&:to&:query',
      pageTrack: '/account/report/expenses',
      template: '<expenses-view  enable-filter-by-agent="true" account-ids="vm.accountIds" agent-ids="vm.agentIds" category-ids="vm.categoryIds" statuses="vm.statuses"' +
        ' from="vm.from" to="vm.to" query="vm.query"></expenses-view>',
      controllerAs: 'vm',
      controller: function (accountId: string, $stateParams) {

        this.accountIds = [accountId]
        this.agentIds = $stateParams.agentIds;
        this.categoryIds = $stateParams.categoryIds;
        this.statuses = $stateParams.statuses;
        this.from = parseInt($stateParams.from);
        this.to = parseInt($stateParams.to);
        this.query = $stateParams.query;
      },
    })


    .state('accounts-detail-supply.commission.commissions', {
      url: '/commissions?:statuses&:from&:to&:query&:commissionDelta&:serviceStatuses',
      pageTrack: '/account/report/commissions',
      template: '<commissions-view account="$ctrl.account" from="vm.from" to="vm.to" statuses="vm.statuses" service-statuses="vm.serviceStatuses"' +
        ' enable-totals="true" commission-delta="vm.commissionDelta"></commissions-view>',
      controllerAs: 'vm',
      controller: function ( commonsService: CommonsService, $stateParams) {
        this.from = parseInt($stateParams.from);
        this.to = parseInt($stateParams.to);
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses);
        this.serviceStatuses = commonsService.parseArrayStateParam($stateParams.serviceStatuses);
        this.commissionDelta = $stateParams.commissionDelta;
      }
    })

    .state('accounts-detail-supply.commission.consolidated-commissions', {
      url: '/consolidated-commissions',
      pageTrack: '/account/report/consolidated-commissions',
      template: '<consolidated-commissions-view account-id="$ctrl.account.id"></consolidated-commissions-view>',
    })

    // Account / Contracts
    .state('accounts-detail-supply.contracts-table', {
      url: '/contracts-table',
      pageTrack: '/account/supply/contracts-table',
      template: '<contracts-table-view account-id="$ctrl.account.id" ></contracts-table-view>',
    })

    .state('accounts-detail-supply.email', {
      url: '/email',
      abstract: true,
      template: '<notifications-configuration is-supply="true"></notifications-configuration>'
    })

    .state('accounts-detail-supply.email.agent', {
      url: '/agent',
      pageTrack: '/account/demand/notifications/email/agent',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="$ctrl.account.id"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.AGENT;
        this.purpose = TextTemplatePurposeType.Email;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, $stateParams, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.Email, $stateParams.id);
        }
      }
    })

}
